import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

import LeftNavFilters from "./components/LeftNav/LeftNavFilters";
import { Route, Switch, useLocation } from "react-router-dom";
import ShipmentSubmitContainer from "./pages/ShipmentSubmitContainer";
import LandingPage from "./pages/LandingPage";
import NavBar from "./components/Nav/NavBar";
import {ROUTES, WHOLESALE_PRICE_SUFFIX} from "./routes";
import ShipmentSubmitFilters from "./components/LeftNav/ShipmentSubmitFilters";
import { useContext } from "react";
import { DueDateContext } from "./contexts/DueDateContext";
import StyledSpinner from "./components/StyledSpinnner/StyledSpinner";
export default function MainPage() {
  const { windowCloses } = useContext(DueDateContext);
  const drawerWidth = 265;
  const { pathname } = useLocation();
  return (
    <Box sx={{ display: "flex", backgroundColor: "rgb(30, 30, 47)" }}>
      <NavBar drawerWidth={drawerWidth}>
        <Drawer
          sx={{
            backgroundColor: "rgb(30, 30, 47)",
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              borderRadius: 0,
            },
          }}
          variant="permanent"
          anchor="left"
        ></Drawer>
      </NavBar>
      {pathname === "/" ? (
        <LeftNavFilters drawerWidth={drawerWidth} />
      ) : (
        <ShipmentSubmitFilters />
      )}
      {Boolean(windowCloses) ? (
        <Box
          style={{
            marginTop: 90,
            marginLeft: 10,
          }}
        >
          <Box component="main" sx={pathname.includes(WHOLESALE_PRICE_SUFFIX) ?
              { bgcolor: "rgb(99,100,101)", p: 2 } :
              { bgcolor: "rgb(30, 30, 47)", p: 2 }}>
            <Switch>
              <Route path="/" exact>
                <LandingPage />
              </Route>
              <Route path={`${ROUTES.NMP}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
                <Route path={`${ROUTES.NMP_WHOLESALE}/:tab`}>
                    <ShipmentSubmitContainer />
                </Route>
              <Route path={`${ROUTES.NSP}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
                <Route path={`${ROUTES.NSP_WHOLESALE}/:tab`}>
                    <ShipmentSubmitContainer />
                </Route>
              <Route path={`${ROUTES.STORE_OWNED}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
              <Route path={`${ROUTES.STORE_HYBRID}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
              <Route path={`${ROUTES.VALUE_STORE}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
              <Route path={`${ROUTES.NIKE_DOT_COM}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
              <Route path={`${ROUTES.CONSIGNMENT}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
              <Route path={`${ROUTES.DROP_SHIP}/:tab`}>
                <ShipmentSubmitContainer />
              </Route>
            </Switch>
          </Box>
        </Box>
      ) : (
        <Box
          height={"100vh"}
          width={"100%"}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <StyledSpinner />
        </Box>
      )}
    </Box>
  );
}
